import apiServer from "../services";
import { createNamespacedHelpers } from "vuex";

const state = {
    saveMode:['save', 'publish'],
    modeArry:['edit', 'add', 'temp'],
    mode:'add',
    courseInfo:{
        ExpCourseId: 0,
        ExpCourseName: "",
        ExpCourseStatus: 0,
        BgMusicUrl: "",
        ExpPrice: 0,
        ExpTemplateId: 0,
        ShareTitle: "",
        ShareImgUrl: "",
        JsonFormValue: "",
        BranchIdList: [],
        SourceUserType:0,
        list:[]
    },
    currentPageId:0,
    currentElementId:0
};
const getters={
    courseData:state=>state.courseInfo,
    pageElements(state,getters){
        return (getters.currentPage&&getters.currentPage.elements||[]);
    },
    currentPage(state){
        var page = null;
        if(state.currentPageId>0){
            page = state.courseInfo.list.find(x=>x.id== state.currentPageId);
        }
        else if(state.courseInfo.list&&state.courseInfo.list.length){
            page = state.courseInfo.list[0];
            state.currentPageId = page.id
        }
        if(page){
            page.elements.forEach(item => {
                item.pageId = page.id;
            });
        }
        return page
    }


};
const mutations ={

    /**
     * 设置模式
     */
    SET_MODE(state, mode){
        state.mode = mode
    },
    /**
     *  特殊逻辑设置用户来源 [机构/校区]
     * @param {*} state 
     * @param {*} from 
     */
    SET_USER_SOURCE(state, from){
        state.courseInfo.SourceUserType = from;
    },
     /**
     * 保存后
     */
    SAVE_AFTER(state, id){
        state.ExpCourseId = id;
        state.mode = state.modeArry[0];
    },
    /**
     * 初始化数据
     */
    LOAD(state, data){
        //初始化用户类型
        state.courseInfo = data;
    },
    /**
     * 保存页面设置
     * @param {page} data
     */
    SAVE_PAGE(state, data){
        state.courseInfo.list.find(x=>x.id== state.currentPageId).name = data.name;        
    },
    /**
     * 保存基础设置
     * @param {name, price, bgMisc} base
     */
    SAVE_BASE(state, base){
        state.courseInfo.ExpCourseName = base.name;
        state.courseInfo.ExpPrice = base.price;
        state.courseInfo.BranchIdList = base.branch;
        state.courseInfo.BgMusicUrl = base.bgMisc;
        state.courseInfo.ShareTitle = base.shareTitle;
        state.courseInfo.ShareImgUrl = base.shareImg;
    },
    /**
     * 更新元素 (当前页面)
     * @param {*} state 
     * @param { eid, type, data} payload
     *   eid : 元素id
     *  type : ['add', 'update', 'del','hide','lock']
     *  data : 元素数据
     */
    SAVE_ELEMENT(state, payload){
        var currentPage = state.courseInfo.list.find(x=>x.id == state.currentPageId)
        if(currentPage && currentPage.elements){
           var element = currentPage.elements.find(x=>x.id == payload.eid);
           if(element){
               if(payload.type == 'update'){
                    element = payload.data
               }else if(payload.type == 'hide'){
                    element.properties.initType = element.properties.initType == 1 ? 2 : 1
               }else if(payload.type == 'lock'){
                    element.properties.editLock = element.properties.editLock == !0 ? !1 :!0
               }
           }
        }
    },    
    /**
     * 移除元素
     * @param {*} state 
     * @param {*} payload 
     */
    REMOVE_ELEMENT(state, payload){
        var currentPage = state.courseInfo.list.find(x=> x.id == state.currentPageId)
        if(currentPage && currentPage.elements){
           var elementIndex = currentPage.elements.findIndex(x=> x.id == payload.eid);
           if(elementIndex > -1){
                currentPage.elements.splice(elementIndex, 1);
           }
        }
    },
    /**
     * 切换页面
     * @param {*} state 
     * @param {index} payload 
     * index 页面集合索引
     * 
     */
    CHANGE_PAGE(state, payload){
        if(state.courseInfo.list){
            var currentPage = state.courseInfo.list[payload.index];
            if(currentPage){
                state.currentPageId = currentPage.id;
                state.currentElementId = 0;
            }
        }
    },
    /**
     * 切换元素
     * @param {*} state 
     * @param {*} payload 
     */
    CHANGE_ELEMENT(state, payload){
        state.currentElementId = payload.eid
    },
    /**
     * 复制页面
     * @param {*} state 
     * @param {index, data} payload
     * index - 复制的页面索引
     * data - 新的页面
     */
    COPY_PAGE(state, payload){
        state.courseInfo.list.splice(payload.index + 1, 0, payload.data)
    },
    /**
     * 删除页面
     * @param {*} state 
     * @param {index, data} payload
     */
    DEL_PAGE(state, payload){
        state.courseInfo.list.splice(payload.index , 1)
    }
};
const actions={  
    /**
     * 保存页面
     * @param {*} param0 
     * @param {*} data 
     */
    savePage({commit,state,getters}, data){
        if(getters.currentPage){
            commit('SAVE_PAGE', data)
        }
    },
    /**
     * 保存
     * @param { saveMode } payload 
     * {saveMode['save','publish'] }
     */
    saveCourse({commit, state, rootState}, payload){
        var savePromise = null;
        let saveData = state.courseInfo;
        saveData.ExpCourseStatus = payload.saveMode=='save'?2:1;
        saveData.JsonFormValue = JSON.stringify(saveData.list);
        if(state.mode == state.modeArry[2]){
            savePromise = apiServer.expCourseTemplate._batchAddTempPage(saveData.list.map(i=>{
                return {
                    tempid:i.sceneId,
                    num:i.num,
                    name:i.name,
                    properties:JSON.stringify(i.properties),
                    elements:JSON.stringify(i.elements),
                    groups:JSON.stringify(i.groups),
                }
            }))                
        }  
        if(payload.extendData&&payload.extendData.isBranch)
        {
            saveData.BranchIdList=[payload.extendData.branchId];
        }
        if(state.mode == state.modeArry[1]){
            savePromise =  apiServer.expCourse._add(saveData)
        }else if(state.mode == state.modeArry[0]){
            savePromise =  apiServer.expCourse._update(saveData)
        }
        return savePromise.then(res=>{
            commit('SAVE_AFTER',res)
            return res;
        })
    },
    /**
     * 初始化
     * @param { mode, id} payload 
     * mode ['edit','add'] id 模板id，砍价id
     * 
     */
    init({commit, state, rootState}, payload){
        let getData=null;
        
        if(payload.mode == state.modeArry[1]
            ||payload.mode == state.modeArry[2]){
            getData =  apiServer.expCourseTemplate._getTempModel({
                id: payload.id
            })
        }else if(payload.mode == state.modeArry[0]){
            getData =  apiServer.expCourse._getModel({
                ExpCourseId:payload.id
            })
        }
        return getData.then(res=>{
            commit('LOAD', res)
            return res;
        })
    }

};

export default {    
    namespaced:true,
    state,
    mutations,
    actions,
    getters
  };



// WEBPACK FOOTER //
// ./src/store/auditions.js